/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox } from '@cleartrip/bento'

import { isEmpty } from 'AccountsUtils'

import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'
import { resolveKeysInObjectsArrays } from 'AccountsUtils'
import OfflineToast from '../offlineToast'
import { SVGComponent } from '../..'
import {
  getLinkedEmailsList,
  verifyOtpForSignIn,
  sendOtpForSignIn
} from '../../../pages/Trips/trips.helper'
import { errorConfig } from './errorConfig'
import OtpBox from './otpBox'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import ModalHeader from '../UserProfileModalHeader'
import SkippableBanner from './SkippableBanner'
import SkippableBannerPWA from './SkippableBannerPWA'
import { invokeCustomEvent } from '../../../utils'
import { path } from '../../../utils'

const verifyMobileNumber = ({
  isPwa,
  isFocus,
  toggle,
  mobileNumber,
  defaultCountryCode,
  setPageName,
  checkboxClass,
  rememberCheckedStatus,
  setRememberCheckedStatus,
  checkBoxTextClass,
  redirectToPage,
  email,
  setMobileNumber,
  toggleModalAndClosePage,
  setLinkedEmails,
  setUserSignedIn,
  abLogin = 'a'
}) => {
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }

  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
  const [otpValidationError, setOtpValidationError] = useState('')
  const [apiError, setApiError] = useState('')
  const [countDown, setCountDown] = useState(30)
  const [retriesLeft, setRetriesLeft] = useState(4)
  const [animationParams, setAnimationParams] = useState(animationDefaultState)
  const [isLoading, setIsLoading] = useState(false)
  const [elementInFocus, setElemntInFocus] = useState(0)

  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-8': 'px-8'
  })

  const getOtpValue = () => {
    const otp = otpDigits.join('')
    return otp
  }

  const [isSticky, setSticky] = useState(true)
  const [vheight, setVheight] = useState(window.innerHeight)
  const [isFullHeight, setFullHeight] = useState(false)
  const [loginSwitch, setLoginSwitch] = useState(true)
  const skippableBlock = useRef(null)
  const loginContainer = useRef(null)
  const bannerAnimationRef = useRef()
  const otpString = otpDigits.join('')
  const handleScroll = () => {
    if (skippableBlock.current.getBoundingClientRect().top < 10) {
      setFullHeight(true)
    }
    // if (skippableBlock.current?.getBoundingClientRect()?.top < 0 ||
    //   skippableBlock.current?.getBoundingClientRect()?.top === 0) {
    //   setSticky(true)
    // }
  }

  useEffect(() => {
    if (isFocus) {
      setSticky(true)
    }
    if (skippableBlock.current.getBoundingClientRect().top < 10) {
      setFullHeight(true)
    } else {
      // setSticky(false)
      setFullHeight(false)
    }
    document.body.classList.add('o-hidden')

    // let containerHeight = skippableBlock.current
    const updateWindowDimensions = () => {
      const newHeight = window.innerHeight
      setVheight(newHeight)
      loginContainer.current.scrollIntoView({ block: 'center' })
    }

    window.addEventListener('resize', updateWindowDimensions)
    return () => {
      window.removeEventListener('resize', updateWindowDimensions)
      document.body.classList.remove('o-hidden')
    }
  }, [loginSwitch, isFocus, isSticky])

  useEffect(() => {
    if (otpString?.length === 4) {
      verifyOtp()
    }
  }, [otpString?.length])

  const handleOnFocus = value => {
    setSticky(true)
  }

  const errorInfo = 'fs-inherit c-inherit pl-2'
  const disabled = getOtpValue().length != 6
  const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
  const pathname = query.split('/')
  const pagePath = pathname[2]
  useEffect(() => {
    refs[0] && refs[0].current && refs[0].current.focus()
    countDownHandler(30)
    ClevertapEvent({
      actionName: 'login_OTP_modal_opened',
      login_banner_cookie: abLogin,
      actionType: 'Button',
      page:
        pagePath === 'results'
          ? 'SRP'
          : isEmpty(pagePath)
            ? 'HP'
            : pathname.length > 4 &&
              pathname[4] === 'info' &&
              pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page'
    })
  }, [])

  const setElementInFocus = index => {
    setElemntInFocus(index)

    refs[index] && refs[index].current && refs[index].current.focus()
  }

  const countDownHandler = (countDown, lastCountdown = false) => {
    if (countDown === 0) {
      return
    }
    if (countDown === 1) {
      if (lastCountdown) {
        setRetriesLeft(-1)
      }
    }
    const updatedCountDown = countDown - 1
    setCountDown(updatedCountDown)
    setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
  }

  const clearOtp = () => {
    const emptyOtpDigits = ['', '', '', '', '', '']
    setOtpDigits(emptyOtpDigits)

    refs[0] && refs[0].current && refs[0].current.focus()
  }
  const resendOtp = async () => {
    ClevertapEvent({
      actionName: 'resend_otp_clicked',
      login_banner_cookie: abLogin,
      page:
        pagePath === 'results'
          ? 'SRP'
          : isEmpty(pagePath)
            ? 'HP'
            : pathname.length > 4 &&
              pathname[4] === 'info' &&
              pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page',
      platform: 'Desktop',
      is_logged_in: 'no',
      domainName: window && window.location.hostname
    })
    // send otp logic
    // set retries = -1 if limit exceed
    setApiError('')
    if (countDown !== 0 || retriesLeft <= 0) {
    } else {
      try {
        const payload = {
          type: 'MOBILE',
          value: mobileNumber,
          countryCode: defaultCountryCode,
          action: email ? 'UPDATE_MOBILE' : 'SIGNIN'
        }
        const response = await sendOtpForSignIn(payload)
        const { status, data, error } = response || {}
        if (status === 202) {
          const { action } = data || {}
          clearOtp()
          countDownHandler(30)
        } else {
          const { response = { data: {} } } = error || {}
          const { data = {} } = response
          const { message } = data
          const err = errorConfig[message] || errorConfig.default
          if (isEmpty(email)) {
            ClevertapEvent({
              actionName: 'Error_Occured_Login_modal',
            login_banner_cookie: abLogin,
              actionType: 'Button',
              page:
                pagePath === 'results'
                  ? 'SRP'
                  : isEmpty(pagePath)
                    ? 'HP'
                    : pathname.length > 4 &&
                      pathname[4] === 'info' &&
                      pathname[2] === 'itinerary'
                      ? 'Itinerary'
                      : 'Confirmation_Page',

              error_type:
                message === 'OTP_SEND_LIMIT_EXCEEDED'
                  ? 'OTP limit exceeded'
                  : 'OTP generation failed'
            })
          }
          setApiError(err)
          if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
            setRetriesLeft(-1)
          }
        }
      } catch (e) {
        console.log('Resend api error', e)
      }
    }
  }

  const otpChangeHandler = (event, index) => {
    setApiError('')
    const value = event.nativeEvent.data || event.target.value
    const numberValue = Number(value)
    if (value === ' ') return
    if (value === '') {
      const otpFieldValues = [...otpDigits]
      otpFieldValues[index] = ''
      setOtpDigits(otpFieldValues)
      return
    }
    if (numberValue >= 0 && Number.isInteger(numberValue)) {
      const otpFieldValues = [...otpDigits]
      otpFieldValues[index] = value % 10
      setOtpDigits(otpFieldValues)
      setElementInFocus(index + 1)
    }
  }
  const otpCursorHandler = (event, index) => {
    if (event.keyCode === 37) {
      setElementInFocus(index - 1)
    }
    if (event.keyCode === 39) {
      setElementInFocus(index + 1)
    }
    if (event.keyCode === 8) {
      if (event.target.value === '') {
        const otpFieldValues = [...otpDigits]
        const indexToRemove = index - 1
        if (indexToRemove < 0) {
          return
        }
        otpFieldValues[indexToRemove] = ''
        setOtpDigits(otpFieldValues)
        setElementInFocus(indexToRemove)
      } else {
        const otpFieldValues = [...otpDigits]
        otpFieldValues[index] = ''
        setOtpDigits(otpFieldValues)
      }
    }
  }

  const verifyOtp = async () => {
    setOtpValidationError('')
    ClevertapEvent({
      actionName: 'Entered_OTP_on_login_modal',
      actionType: 'Button',
      login_banner_cookie: abLogin,
      page:
        pagePath === 'results'
          ? 'SRP'
          : isEmpty(pagePath)
            ? 'HP'
            : pathname.length > 4 &&
              pathname[4] === 'info' &&
              pathname[2] === 'itinerary'
              ? 'Itinerary'
              : 'Confirmation_Page'
    })
    setIsLoading(true)
    const otp = getOtpValue()
    const payload = {
      type: 'MOBILE',
      value: mobileNumber,
      countryCode: defaultCountryCode,
      action: email ? 'UPDATE_MOBILE' : 'SIGNIN',
      otp
    }
    try {
      const response = await verifyOtpForSignIn(payload)
      const { status, data, error } = response || {}
      if (status === 200) {
        invokeCustomEvent('CLEVERTAP_PROFILE', { type: 'login' })
        const { action } = data || {}
        if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
          window.MobileApp.onPWALoginStatus(
              JSON.stringify({
                  isSignIn: true
              })
          )
      }

        if (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) {
            window.webkit.messageHandlers['PWA_IS_SIGNIN'].postMessage({
                isSignIn: true
            })
        }
        if (action === 'SIGNIN') {
          ClevertapEvent({
            actionName: 'Login_succesful',
            login_banner_cookie: abLogin, 
            actionType: 'Button',
            action:'signin',
            page:
              pagePath === 'results'
                ? 'SRP'
                : isEmpty(pagePath)
                  ? 'HP'
                  : pathname.length > 4 &&
                    pathname[4] === 'info' &&
                    pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            login_type: 'Mobile',
            first_time_login: 'No',
            keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
          })

          setUserSignedIn(true)
          window.localStorage.setItem('LoginToastShown','true')

          // const res = await checkForLinkingNudge()
          // const { status, data } = res || {}
          // if (status === 200) {
          // if (data.action) {
          //     setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
          // } else {
          toggleModalAndClosePage()
          // }
          // } else {
          //     const { message } = data
          //     const error = errorConfig[message] || errorConfig.default
          //     setApiError(error)
          // }
        }
        if (action === 'SIGNUP') {
          ClevertapEvent({
            actionName: 'Login_succesful',
            login_banner_cookie: abLogin,
            actionType: 'Button',
            action:'signup',
            page:
              pagePath === 'results'
                ? 'SRP'
                : isEmpty(pagePath)
                  ? 'HP'
                  : pathname.length > 4 &&
                    pathname[4] === 'info' &&
                    pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            login_type: 'Mobile',
            first_time_login: 'Yes',
            keep_me_logged_in: rememberCheckedStatus ? 'Yes' : 'No'
          })
          setUserSignedIn(true)
          window.localStorage.setItem('LoginToastShown','true')
          if (
            pathname.length > 4 &&
            pathname[4] === 'info' &&
            pathname[2] === 'itinerary'
          ) {
            toggle()
          } else {
            const payload = {
              mobileNumber,
              countryCode: defaultCountryCode
            }
            const res = await getLinkedEmailsList(payload)
            const { status, data, error } = res || {}
            if (status === 200) {
              // if (!isEmpty(data)) {
              setLinkedEmails(data)
              ClevertapEvent({
                action_name: 'existing_email_modal_opened',
                action: 'signup',
                page:
                  pagePath === 'results'
                    ? 'SRP'
                    : isEmpty(pagePath)
                      ? 'HP'
                      : pathname.length > 4 &&
                        pathname[4] === 'info' &&
                        pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',
                is_logged_in: 'yes'
              })
              setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_LINKED)
              // }
              // TODO when fk apis are ready
              // else {
              //     const res = await checkForLinkingNudge()
              //     const { status, data } = res || {}
              //     if (status === 200) {
              //         if (data.action) {
              //             setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
              //         } else {
              //             setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
              //         }
              //     } else {
              //         const { message } = data
              //         const error = errorConfig[message] || errorConfig.default
              //         setApiError(error)
              //     }
              // }
            } else {
              const { response = { data: {} } } = error || {}
              const { data = {} } = response
              const { message } = data
              const err = errorConfig[message] || errorConfig.default
              // setApiError(err)
              setPageName(USER_PROFILE_PAGE_CONTANTS.PERSONAL_DETAILS)
            }
          }
        }
        // if email present then to link mobile to fk
        if (action === 'UPDATE_MOBILE') {
          // const res = await checkForLinkingNudge()
          // const { status, data } = res || {}
          // if (status === 200) {
          //     if (data.action) {
          //         setPageName(USER_PROFILE_PAGE_CONTANTS.LINK_ACCOUNTS)
          //     } else {
          toggle()

          //     }
          // } else {
          //     const { message } = data
          //     const error = errorConfig[message] || errorConfig.default
          //     setApiError(error)
          // }
        }
      } else {
        const { response = { data: {} } } = error || {}
        const { data = {} } = response
        const { message } = data
        const errRes = errorConfig[message] || errorConfig.default
        if (isEmpty(email)) {
          ClevertapEvent({
            actionName: 'Error_Occured_Login_modal',
            login_banner_cookie: abLogin,
            actionType: 'Button',
            page:
              pagePath === 'results'
                ? 'SRP'
                : isEmpty(pagePath)
                  ? 'HP'
                  : pathname.length > 4 &&
                    pathname[4] === 'info' &&
                    pathname[2] === 'itinerary'
                    ? 'Itinerary'
                    : 'Confirmation_Page',

            error_type: 'OTP verification failed'
          })
        }
        if (message === 'INVALID_OTP') {
          setOtpValidationError(errRes)
        } else {
          setApiError(errRes)
        }
      }
    } catch (e) {
      console.log('verify Otp api error', e)
    }
    setIsLoading(false)
  }

  const otpBlock = [1, 2, 3, 4].map((element, index) => {
    return (
      <OtpBox
        key={index}
        onKeyDown={e => otpCursorHandler(e, index)}
        onChange={e => otpChangeHandler(e, index)}
        onMouseDownCapture={() => {
          setElementInFocus(index)
        }}
        ref={refs[index]}
        value={otpDigits[index]}
        style={{
          margin: `11px ${index === 5 ? '0px' : '10px'} 14px 0px`,
          border: otpValidationError
            ? ' solid 1px #ff3c2b'
            : refs[index] && refs[index].current === document.activeElement
              ? 'solid 1px #36c'
              : 'solid 1px #e6e6e6'
        }}
      />
    )
  })

  useEffect(() => {
    const OutsideClickHandler = event => {
      if (!bannerAnimationRef.current.contains(event.target)) toggle()
    }
    document.addEventListener('mousedown', OutsideClickHandler)
    return () => {
      document.removeEventListener('mousedown', OutsideClickHandler)
    }
  })

  useEffect(() => {
    if (otpValidationError) {
      clearOtp()
    }
  }, [otpValidationError])

  return (
    <div
      ref={bannerAnimationRef}
      onScroll={handleScroll}
      className={`${isSticky ? 't-0 bg-white' : 'b-0 flex-between '} 
    ${isPwa
          ? 'flex flex-column overflow-y-scroll z-2 w-100p p-fixed'
          : ' d-flex'
        } 
  
        `}
      style={{
        background: isPwa ? '#00000080' : '#ffffff',
        height: isPwa ? vheight : 'auto'
      }}
    >
      {isPwa && (
        <div className="p-sticky t-0 w-100p p-fixed z-20 ">
          {isSticky && (
            <div className="bg-orange-100 bg-white-f7 elevation-lg flex flex-row flex-middle">
              <span
                className="d-ib px-5  py-4 fs-12 fw-700 c-white"
                onClick={toggle}
              >
                <SVGComponent
                  svgIcon="crossDark"
                  height={24}
                  width={24}
                  className="c-pointer c-white"
                />
              </span>
              <span className="d-ib fs-16 fw-600 lh-24 c-black">
                Sign up / Log in
              </span>
            </div>
          )}
        </div>
      )}

      <div ref={skippableBlock}>
        {isPwa ? (
          <SkippableBannerPWA isSticky={isSticky} toggle={toggle} isPwa={isPwa} abLogin={abLogin} />
        ) : (
          <SkippableBanner abLogin={abLogin}/>
        )}
      </div>

      <div
        onKeyDown={e => {
          if (e.key === 'Enter') {
            if (!disabled) {
              verifyOtp()
            }
          }
        }}
        style={{
          width: isPwa ? 'auto' : '416px',
          height: '437px'
        }}
        className={`${animatedClass} d-flex flex-1 flex-column bg-white`}
      >
        {isPwa ? (
          <div className="pt-6" />
        ) : (
          <ModalHeader title="" toggle={toggle} />
        )}

        <OfflineToast
          page={isEmpty(email) ? 'proceed' : 'verify mobile number'}
        />
        {apiError && (
          <>
            <div
              style={{ marginBottom: '22px' }}
              className="py-3 px-2 flex flex-middle bg-error-600 c-white fs-2 br-4"
            >
              <SVGComponent
                svgIcon="info_icon"
                className="c-white"
                height={16}
                width={16}
              />
              <span className={errorInfo}>{apiError}</span>
            </div>
          </>
        )}

        <div className="d-flex flex-column flex-between flex-1">
          <div>
            <div
              className={`c-pointer flex flex-middle ${isLoading ? 'c-neutral-200' : 'c-secondary-500'
                } fs-3 fw-500`}
            >
              <div style={{ marginLeft: '-2px' }}>
                <SVGComponent
                  svgIcon="arrow_left"
                  height={18}
                  className="c-inherit"
                />
              </div>{' '}
              <span
                style={{ marginTop: '-3px' }}
                className="fs-2 fw-500"
                onClick={() => {
                  setMobileNumber('')
                  if (isEmpty(email)) {
                    setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNIN)
                  } else {
                    setPageName(USER_PROFILE_PAGE_CONTANTS.EMAIL_MOBILE_LINKED)
                  }
                }}
              >
                {'Change number'}
              </span>
            </div>
            <Spacer className="pt-6" />
            <p className="fs-3 c-neutral-700">
              <span className="fs-3 c-neutral-700">
                {' '}
                {'Enter OTP sent to the number '}{' '}
              </span>
              <span className="fs-3 c-neutral-700 fw-600">{`${defaultCountryCode} ${mobileNumber}`}</span>
            </p>
            <div className="d-flex">{otpBlock}</div>
            {otpValidationError && (
              <div className="c-error-500 mb-3" style={{ marginTop: '-8px' }}>
                {otpValidationError}
              </div>
            )}
            <div style={{ marginBottom: '29px' }}>
              <span className="fs-2 c-neutral-700">Haven't received OTP?</span>
              <div ref={loginContainer} />

              <span
                onClick={resendOtp}
                className={`fs-2 fw-500 ml-1 ${retriesLeft === -1
                  ? 'c-neutral-200'
                  : countDown !== 0
                    ? 'c-neutral-200'
                    : isLoading
                      ? 'c-neutral-200'
                      : 'c-blue c-pointer'
                  }`}
              >
                {retriesLeft === -1
                  ? 'Resend'
                  : countDown !== 0
                    ? `Resend (${countDown}s)`
                    : 'Resend'}
              </span>
            </div>
            {isEmpty(email) && (
              <Checkbox
                className={checkboxClass}
                checked={rememberCheckedStatus}
                onClick={() => setRememberCheckedStatus(!rememberCheckedStatus)}
              >
                <span className={checkBoxTextClass}>Keep me logged in</span>
              </Checkbox>
            )}
          </div>

          {/* <div className="pt-40">
            <Button
              disabled={disabled}
              size="md"
              type="secondary"
              full={true}
              busy={isLoading}
              onClick={() => verifyOtp()}
            >
              <span className={`${disabled ? 'c-grey-30' : ''} fs-3 fw-500`}>
                {'Verify and continue'}
              </span>
            </Button>
            <Spacer className="mb-8" />
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default verifyMobileNumber
